import React, { useState } from "react";

import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "@/src/components/ui/button";

import { SET_LOCALE } from "../../actions/ActionTypes";
import i18n, { allowedLng } from "../../i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

import type { JSX } from "react";
import type { Dispatch } from "redux";

import type { AppState } from "../../reducers";

interface LangSelectorProps {
  languages?: readonly string[];
}

interface SetLocaleAction {
  type: typeof SET_LOCALE;
  lang: string;
}

function LangSelector({ languages }: LangSelectorProps): JSX.Element {
  const dispatch = useDispatch<Dispatch<SetLocaleAction>>();
  const lang = useSelector((state: AppState) => state.variableReducer.lang);
  const [open, setOpen] = useState(false);

  const changeLanguage = (language: string): void => {
    i18n.changeLanguage(language);
    dispatch({ type: SET_LOCALE, lang: language });
    setOpen(false);
  };

  return (
    <DropdownMenu onOpenChange={setOpen} open={open}>
      <DropdownMenuTrigger asChild>
        <Button className="ml-5 uppercase" variant="outline">
          {lang}
          <KeyboardArrowDownIcon className="editor-icon language_icon" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" sideOffset={20}>
        <div className="menu-arrow-background" />
        {(languages ?? allowedLng).map((language) => (
          <DropdownMenuItem
            key={language}
            className="uppercase"
            onClick={(): void => {
              changeLanguage(language);
            }}
          >
            {language}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LangSelector;
